//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      showDrop: false,
      list: [
        {
          title: "首页",
          name: "index"
        },
        {
          title: "院校指南",
          name: "school"
        },
        {
          title: "留学资讯",
          name: "Overseas"
        },
        {
          title: "所有服务",
          name: "Allservices"
        },
        {
          title: "联系我们",
          name: "popdetais"
        }
      ],
      keyValue: ""
    };
  },
  props: {
    keyword: {
      type: String,
      default: ""
    }
  },
  computed: {},
  watch: {
    keyword: function(newValue, oldValue) {
      this.keyValue = newValue;
    }
  },
  methods: {
    toSearch() {
      this.showDrop = false;
      this.$router.push({
        path: "/search"
      });
    },
    search() {
      this.$emit("on-search", this.keyValue);
    },
    clear() {
      this.$emit("on-close", "");
    },
    jump(name) {
      if (this.$route.name !== name) {
        console.log(this.$route.name)
        if (name == "popdetais") {
          this.showDrop = false;
          this.$api.Articledetails(4).then(res => {
            if(res.data.code==0){
              let data = res.data.data
              console.log(res)
              if(data.url){
                window.location.href=data.url
              }else{
                this.$router.push({
                  name: "popdetais",
                  query: {
                    id: 4
                  }
                });
              }
            }
          });
        }else {
          this.showDrop = false;
          this.$router.push({
            name: name
          });
        }
      } else {
        this.showDrop = false;
        console.log("当前页面");
      }
    },
    toIndex(){
      this.showDrop = false;
      if(this.$route.name !== 'index'){
        this.$router.push({
          name: "index",
        });
      }
    }
  },
  created() {}
};



// WEBPACK FOOTER //
// ./src/components/Nav.vue